module.exports = __webpack_public_path__ + "media/images/products/marketplace/3-7185490fa803725c7349d1a5621befd7.jpg";